/** @format */

import { useState } from "react";

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

import {
  BlockBtn,
  BtnRed,
  MenuBtn,
  UnBLock,
} from "../../components/global/btns/btns";

//import table data
import { tableColumnGuarantorVarify } from "../../components/table/col-data";
import { InternalNav } from "../../components/internalNav";
import { PersonalData } from "../../components/guarantor/profileForm";
import { UserCard } from "../../components/guarantor/userCard";
import { PersonalPaper } from "../../components/guarantor/PersonalPaper";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOne } from "../../store/helper";
import { Spinner1 } from "../../components/spinners/Spinner1";
import {
  baneClient,
  deleteClient,
  getClient,
  getClientOrders,
  updateClient,
} from "../../services/clintServices";
import { client_orders } from "../../constant/table";

import DeleteModal from "../../components/pops/global modals/deleteModal";
import { showDeleteServiceSecton } from "../../store/stateSlice";
import ActionModal from "../../components/pops/global modals/action-modal";
import Table from "../../components/Table2";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";

const ProfileGuarantor = () => {
  //handle state
  const [active, setActive] = useState("history");
  const [block, setBlock] = useState(false);
  const [selectedAction, setActionObj] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [isOpen, setOpen] = useState(false);

  // handle redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { client, clientOrders, loading } = useSelector(
    (state) => state.clientSlice
  );

  // extract params
  const { id } = useParams();
  const handleActivateClick = () => {
    dispatch(
      updateClient({
        url: "/clients/" + id,
        data: { status: "active", name: client.name, phone: client.phone },
      })
    ).then((res) => {
      dispatch(getClient("/clients/" + id));
      setOpen(false);
    });
  };
  const handleBaneClient = () => {
    dispatch(baneClient("/client-banned/" + id)).then((res) => {
      // dispatch(baneClientAction(client));
      dispatch(getClient("/clients/" + id));
      setOpen(false);
      setShowBlockModal(false);
    });
  };

  const handleDeleteClient = () => {
    dispatch(deleteClient("/clients/" + id)).then(() => {
      navigate("/guarantor");
    });
  };

  useEffect(() => {
    dispatch(getClientOrders("/client_orders/" + id));
    dispatch(getClient("/clients/" + id));
  }, [id]);
  let modalOj = {
    bane: {
      type: "bane",
      title: "هل تريد حظر هذا الكفيل ؟",
      action: handleBaneClient,
    },
    delete: {
      type: "delete",
      title: "هل تريد حذف هذا الكفيل ؟",
      action: handleDeleteClient,
    },
    activate: {
      type: "activate",
      title: "هل تريد اعادة تفعيل هذا الكفيل ؟",
      action: handleActivateClick,
    },
  };
  const actionBtn = (buttonName) => {
    setOpen(true);

    setActionObj(modalOj[buttonName]);
  };
  return (
    <NavbarAndSidebar>
      <ActionModal
        data={client}
        type={selectedAction.type}
        showModal={isOpen}
        setShowModal={setOpen}
        msg={selectedAction.title}
        action={selectedAction.action}
      />
      {loading && <Spinner1 />}

      <div className='profile__head mb__small'>
        <HeadTitle title='الكفيل' />
        <div className='row-flex'>
          {client.status === "active" ? (
            <BtnRed action={() => actionBtn("bane")} value='حظر' />
          ) : (
            <UnBLock action={() => actionBtn("activate")} />
          )}
          <BtnRed value='حذف' action={() => actionBtn("delete")} />
        </div>
      </div>

      <UserCard block={client.status === "banned"} />
      <div className='mb__small' />
      <InternalNav active={active} setActive={setActive} from='guarantor' />
      <div className='mb__small' />

      {active === "history" && (
        <div>
          <MenuBtn />
          <div className='mb__small' />

          <Table
            data={clientOrders?.data}
            header={client_orders}
            link='/guarantor/'
            name='clientOrders'
            // getSearchValue={getSearchValue}
            // searchValues={searchValues}
          />
        </div>
      )}

      {active === "data" && <PersonalData block={block} />}

      {active === "papers" && <PersonalPaper />}
    </NavbarAndSidebar>
  );
};
export default ProfileGuarantor;
